// src/features/profile/api/profile/read.js
import axiosInstance from '@/lib/axios';




export async function fetchUserControl() {

  const response = await axiosInstance.get('/admin/registerd_users');
  return response.data;

}


export async function adminAction({ target_user_ids, action_type, reason, ban_expires_at }) {


  const response = await axiosInstance.post('/admin/actions', {
    target_user_ids,  // always send an array, even for a single user
    action_type,
    reason,
    ban_expires_at,
  });



  console.log(response.data)
  return response.data;
}




// ✅ Fetch ratings for a user (admin)
export async function fetchRatings({ user_id }) {

  const response = await axiosInstance.get(`/admin/ratings/${user_id}`);
  return response.data;

}

// ✅ Fetch reports for a user (admin)
export async function fetchReports(user_id) {

  const response = await axiosInstance.get(`/admin/reports/${user_id}`);
  return response.data;

}

// ✅ Fetch event history (admin)
export async function fetchEventHistory() {
  const response = await axiosInstance.get('/admin/eventhistory');
  return response.data;

}






export async function fetchMatchHistory(page, limit = 10) {
  // Use template literal to inject the page number
  const response = await axiosInstance.get(`/admin/matchhistory/${page}?limit=${limit}`);
  return response.data;
}



export async function fetchMatchReport() {

  const response = await axiosInstance.get('/admin/report/match');
  return response.data;

}






export async function fetchBanLogs(user_id) {


  const response = await axiosInstance.get(`/admin/ban_logs/${user_id}`);

  return response.data;

}






export async function fetchWarnLogs(user_id) {


  const response = await axiosInstance.get(`/admin/warning_logs/${user_id}`);

  return response.data;

}




export async function reverseBan(action_id) {


  const response = await axiosInstance.delete(`/admin/actions/${action_id}`);

  return response.data;

}



export async function fetchAvailableSports() {


  const response = await axiosInstance.get(`/users/preferences/sports`);

  return response.data;

}
